import { TFunction } from 'i18next';
import { enqueueSnackbar } from 'notistack';

export const handleNoCertificatesSelected = (t: TFunction<'ns1', undefined>) => {
  enqueueSnackbar({
    message: t('tables.finishedHearingCouncilsAnalysis.alertMessage'),
    variant: 'warning',
  });
};
